/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Origin_Space_ManagementInputs */



/**
* | output |
* | --- |
* | "Space Management" |
*
* @param {Audit_Origin_Space_ManagementInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_origin_space_management = /** @type {((inputs?: Audit_Origin_Space_ManagementInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Origin_Space_ManagementInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Space-Verwaltung")
	return /** @type {LocalizedString} */ ("Space Management")
});